export default "__VITE_ASSET__2b3de17b__"